(function () {
	// Fixed 2026-08-28. Every element below was queried and then used without
	// checking it exists. On any page where one of them is absent, line 29 threw
	// "Cannot read properties of null (reading 'addEventListener')" and execution
	// stopped there, so the submenu accordions and the Escape-to-close handler
	// further down never bound at all. Guards added; behaviour is unchanged
	// wherever the elements do exist.
	const header = () => {
		const body = document.querySelector("body");
		const openBtn = document.querySelector(".header__offcanvas-toggle");
		const closeBtn = document.querySelector(
			".header__offcanvas-toggle-link--close",
		);
		const offMenu = document.querySelector(".header__offcanvas-menu");
		const searchDetails = document.querySelector(".header__details");
		const openSearchBtn = document.querySelector(".header__search");
		const searchModal = document.querySelector(".search-modal");
		const submenuDetails = document.querySelectorAll(
			".header__submenu li details",
		);

		const openMenu = (e) => {
			e.preventDefault();
			if (offMenu) offMenu.classList.add("header__offcanvas-menu--open");
			if (openBtn) openBtn.classList.add("active");
			if (body) body.classList.add("body--hidden");
		};

		const closeMenu = () => {
			if (offMenu) offMenu.classList.remove("header__offcanvas-menu--open");
			if (openBtn) openBtn.classList.remove("active");
			if (body) body.classList.remove("body--hidden");
		};

		if (openBtn) openBtn.addEventListener("click", openMenu);
		if (closeBtn) closeBtn.addEventListener("click", closeMenu);

		if (openSearchBtn) {
			openSearchBtn.addEventListener("click", () => {
				if (searchDetails && searchDetails.open) {
					if (body) body.classList.add("body--hidden");
					setTimeout(() => {
						if (searchModal) {
							searchModal.classList.add("search-modal--overflow");
						}
					}, 1000);
				} else {
					if (body) body.classList.remove("body--hidden");
					if (searchModal) {
						searchModal.classList.remove("search-modal--overflow");
					}
				}
			});
		}

		submenuDetails.forEach((targetDetail) => {
			targetDetail.addEventListener("click", () => {
				submenuDetails.forEach((detail) => {
					if (detail !== targetDetail) {
						detail.removeAttribute("open");
					}
				});
			});
		});

		document.addEventListener("keyup", (e) => {
			if (e.key === "Escape") {
				closeMenu();
				if (searchDetails) searchDetails.removeAttribute("open");
			}
		});
	};

	document.addEventListener("shopify:section:load", header);

	header();
})();
